'use client';

import React, { useEffect } from 'react';
import ThankYou from 'components/commercetools-ui/organisms/thank-you';
import { useAccount } from 'frontastic/hooks';
import useLocale from 'helpers/hooks/useLocale';
import { DataLayerOnLoad } from 'helpers/dataLayerHelpers';
import { TasticProps } from '../types';
import { ImageProps } from 'frontastic/lib/image';
import { useCookies } from 'react-cookie';

const ThankYouTastic = ({ ...props }: TasticProps<{ productLogo: ImageProps }>) => {
  const { getCountry, getCurrency } = useLocale();
  const { account } = useAccount();
  const [cookie, setCookie] = useCookies(['guest-session']);

  useEffect(() => {
    const localeData = {
      country: getCountry(),
      currency: getCurrency(),
    };
    const currentUrl = document.location.origin;
    const dataLayer = new DataLayerOnLoad(currentUrl, 'thank-you', localeData, account);
    dataLayer.setDataLayerOnLoad();
    const guestSession = cookie['guest-session'];
    if (guestSession) {
      setCookie('guest-session', '', { path: '/', maxAge: 0 });
    }
  }, []);
  return <ThankYou productLogo={props.data.productLogo} />;
};

export default ThankYouTastic;
